import { Injectable, inject } from '@angular/core';
import {ApplicationInsightsService} from '../application-insights.service';

@Injectable({
  providedIn: 'root'
})
export class AuthWebservice {
  private readonly applicationInsightsService = inject(ApplicationInsightsService);

  token: string;
  isAuth = false;
  isAuthBDD = false;

  signOutUser() {
    localStorage.clear();
    sessionStorage.clear();
    this.token = null;
    this.isAuth = false;
    this.isAuthBDD = false;
    this.applicationInsightsService.clearUserId();
  }
}
